import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import {
  updateStatusForOrder,
  updateOrderDispatchDate,
  fetchParsialDipatchData,
  addQueData,
  EditUpdateQuaintity,
  deleteProductionHistory,
  deleteProductImage,
  ViewOrderProductImage,
  getOrderLogs,
  editOrderById,
  updateQTY,
  deleteOrder,
} from "../../../../DriftRoutes/contextsApi";

export const useOrderActions = ({
  orders,
  setOrders,
  fetchOrders,
  refreshOrders,
  showLoader,
  hideLoader,
  setSelectedOrder,
  setSelectedProduct,
  setSelectedProductId,
  setSelectedQueues,
  setLogsContent,
  setLogsOrderId,
  setModalState,
  debouncedSearch,
  searchField,
  searchValue,
}) => {
  const [isProcessing, setIsProcessing] = useState({
    saving: false,
    deleting: false,
    partialDispatch: false,
    queue: false,
    loading: false,
    savingDispatchId: null,
  });

  // Local state for partial dispatch (matching old code)
  const [partialDispatchData, setPartialDispatchData] = useState({
    vehicleNumber: "",
    vehicleType: "",
    driverName: "",
    dispatcherName: "",
    notes: "",
    partialQuantities: {},
  });
  const [partialDispatchProducts, setPartialDispatchProducts] = useState([]);
  const [selectedOrderIndex, setSelectedOrderIndex] = useState(null);
  const [pendingStatus, setPendingStatus] = useState("");
  const [totalQuantityInPieces, setTotalQuantityInPieces] = useState(0);
  const [dispatchRemark, setDispatchRemark] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [dispatchDate, setDispatchDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const handleEditOrder = useCallback(
    async (order) => {
      showLoader?.();
      try {
        const response = await editOrderById(order._id, order.masterId);
        const editData = response?.success?.[0];

        if (!editData) {
          throw new Error("No order data received");
        }

        // Transform data for the form
        const transformProductImages = (images) => {
          if (!images) return [];
          return images.map((img) => {
            if (typeof img === "string") {
              return {
                url: extractRelativePath(img),
                name: img.split("/").pop() || "product_image",
                type: img.endsWith(".pdf") ? "application/pdf" : "image/*",
              };
            }
            return {
              ...img,
              url: extractRelativePath(img.url || img),
            };
          });
        };

        const orderData = {
          neworderid: editData.neworderid || "",
          ordertype: editData.ordertype || "",
          cust_id: editData.customer?.cust_id || "",
          custName: editData.customer?.custName || "",
          phoneno: editData.customer?.phoneno || "",
          email: editData.customer?.email || "",
          companylistcust: editData.customer?.companylistcust || "",
          address: editData.customer?.address || "",
          city: editData.customer?.city || "",
          zipcode: editData.customer?.zipcode || "",
          state: editData.customer?.state || "",
          country: editData.customer?.country || "",
          customer_refrence_number:
            editData.customer?.customer_refrence_number || "",
          order_date: editData.order_date?.split("T")[0] || "",
          productionDays: editData.productionDays || "",
          tentative_date:
            editData.dispatch_date_production?.split("T")[0] ||
            editData.tentative_date?.split("T")[0] ||
            "",
          product: (editData.product || []).map((prod) => ({
            prodName: prod.prodName || "",
            product_type: prod.product_type || "",
            design_name: prod.design_name || "",
            color_name: prod.color_name || "",
            pcs_sqft: prod.pcs_sqft || "",
            sqft_pcs: prod.sqft_pcs || "",
            queue_status: prod.queue_status || "0",
            quantity_in_soft: prod.quantity_in_soft || "",
            quantity_in_pieces: prod.quantity_in_pieces?.toString() || "",
            order_remark: prod.order_remark || "",
            product_id: prod.product_id || "",
            Product_update: prod.Product_update || [],
            production_update: prod.production_update || [],
            remaining_production_update: prod.remaining_production_update || "",
            total_completed_pieces: prod.total_completed_pieces || "",
            product_image: transformProductImages(prod.product_image) || [],
          })),
        };

        return orderData;
      } catch (error) {
        console.error("Edit error:", error);
        toast.error("Failed to load order data for editing.");
        throw error;
      } finally {
        hideLoader?.();
      }
    },
    [showLoader, hideLoader],
  );

  const handleDeleteOrder = useCallback(
    async (orderId) => {
      setIsProcessing((prev) => ({ ...prev, deleting: true }));
      showLoader?.();
      try {
        await deleteOrder(orderId);
        toast.success("Order deleted successfully");
        await refreshOrders();
        setModalState((prev) => ({ ...prev, showDelete: false }));
      } catch (error) {
        console.error("Error deleting order:", error);
        toast.error("Failed to delete order");
      } finally {
        setIsProcessing((prev) => ({ ...prev, deleting: false }));
        hideLoader?.();
      }
    },
    [refreshOrders, setModalState, deleteOrder, toast],
  );

  const handleQuantity = useCallback(
    async (order, type, payload) => {
      setIsProcessing((prev) => ({ ...prev, saving: true }));
      showLoader?.();
      try {
        const response = await updateQTY(payload);
        if (response) {
          toast.success("Quantity updated successfully");
          await refreshOrders();
          setModalState((prev) => ({ ...prev, showQuantity: false }));
        }
      } catch (error) {
        console.error("Error updating quantity:", error);
        toast.error("Failed to update quantity");
      } finally {
        setIsProcessing((prev) => ({ ...prev, saving: false }));
        hideLoader?.();
      }
    },
    [refreshOrders, setModalState, updateQTY, toast],
  );

  // This is the main changeStatus function from old code
  const changeStatus = useCallback(
    async (index, newStatus, partialData = {}) => {
      showLoader?.();
      try {
        const order = orders[index];
        console.log("changeStatus called:", {
          index,
          newStatus,
          order,
          partialData,
        });

        // Save the current product data before update
        const currentProducts = order.product || [];

        // Call the API
        await updateStatusForOrder(
          order._id,
          order.status,
          newStatus,
          partialData,
          dispatchRemark,
          attachments,
          order.orderId || order.neworderid,
          dispatchDate,
        );

        // Reset dispatch remark
        setDispatchRemark("");

        // Update local state while preserving product data
        setOrders((prev) => {
          const updated = [...prev];
          updated[index] = {
            ...updated[index],
            status: newStatus,
            product: currentProducts, // Maintain the product reference
          };
          return updated;
        });

        await fetchOrders();
        toast.success(`Order status updated to ${newStatus}`);
      } catch (error) {
        console.error("Error updating status:", error);
        toast.error(
          error.response?.data?.message || "Failed to update order status",
        );

        // Revert the select back to original status
        const selectElement = document.querySelector(
          `select[data-order-index="${index}"]`,
        );
        if (selectElement) {
          selectElement.value = orders[index].status;
        }
      } finally {
        hideLoader?.();
      }
    },
    [
      orders,
      setOrders,
      fetchOrders,
      dispatchRemark,
      attachments,
      dispatchDate,
      updateStatusForOrder,
      toast,
    ],
  );

  // This is the handleStatusChange from old code
  const handleStatusChange = useCallback(
    async (e, index, order, dispatchData) => {
      console.log("e.target.value", e.target.value);
      const newStatus = e.target.value;
      const actualIndex = orders.findIndex((o) => o.orderId === order.orderId);

      console.log("handleStatusChange:", { actualIndex, newStatus, order });

      if (actualIndex === -1) {
        console.error("Order not found:", order.orderId);
        toast.error("Order not found");
        return;
      }

      if (newStatus === "partialdispatch") {
        console.log("Processing partial dispatch for order:", order.orderId);
        setSelectedOrderIndex(actualIndex);
        setSelectedOrder(order);
        setModalState((prev) => ({ ...prev, showPartialDispatch: true }));
        showLoader?.();

        try {
          const response = await fetchParsialDipatchData(order.orderId);

          // Update orders with product data
          setOrders((prev) => {
            const updated = [...prev];
            updated[actualIndex] = {
              ...updated[actualIndex],
              product: response.products || [],
            };
            return updated;
          });

          setPartialDispatchProducts(response.data || []);

          const initialPartialQuantities = {};
          response.products?.forEach((product) => {
            initialPartialQuantities[product.product_id] = 0;
          });

          setPartialDispatchData((prev) => ({
            ...prev,
            partialQuantities: initialPartialQuantities,
          }));

          setTotalQuantityInPieces(order.quantityInPcs || 0);
          setModalState((prev) => ({ ...prev, showPartialDispatch: true }));
        } catch (error) {
          console.error("Error fetching partial dispatch data:", error);
          toast.error("Failed to load partial dispatch data");
        } finally {
          setIsProcessing((prev) => ({ ...prev, partialDispatch: false }));
          hideLoader?.();
        }
      } else if (newStatus === "dispatch") {
        console.log("Processing dispatch for order:", order.orderId);
        // setSelectedOrderIndex(actualIndex);
        // setPendingStatus(newStatus);
        // setModalState((prev) => ({ ...prev, showDispatchRemarks: true }));
        setSelectedOrder(order);
        setSelectedOrderIndex(actualIndex);
        setPendingStatus(newStatus);
        setModalState((prev) => ({ ...prev, showDispatchRemarks: true }));
      } else if (newStatus === "processing") {
        const partialData = {
          notes: "",
          vehicleDetails: {
            vehicleNumber: "",
            vehicleType: "",
            dispatcherName: "",
            driverName: "",
            value: "0",
          },
          products: (order.products || []).map((p) => ({
            product_id: p.product_id,
            updateQuanInPic: 0,
          })),
        };
        await changeStatus(actualIndex, newStatus, partialData);
      } else {
        await changeStatus(actualIndex, newStatus);
      }
    },
    [
      orders,
      setOrders,
      changeStatus,
      setModalState,
      fetchParsialDipatchData,
      toast,
    ],
  );

  const handlePartialDispatchSave = useCallback(async () => {
    setIsProcessing((prev) => ({ ...prev, partialDispatch: true }));
    showLoader?.();
    try {
      const {
        vehicleNumber,
        vehicleType,
        driverName,
        dispatcherName,
        notes,
        partialQuantities,
      } = partialDispatchData;

      // Validate vehicle and dispatcher details
      if (
        !vehicleNumber?.trim() ||
        !vehicleType?.trim() ||
        !driverName?.trim() ||
        !dispatcherName?.trim()
      ) {
        toast.error("All vehicle and dispatcher details are required");
        return;
      }

      // Calculate sum of partial quantities
      const sumOfPartialQuantities = Object.values(partialQuantities).reduce(
        (sum, qty) => sum + (Number(qty) || 0),
        0,
      );

      // Validate partial quantities
      let hasValidationError = false;
      partialDispatchProducts.forEach((product) => {
        const partialQty = Number(partialQuantities[product.product_id]) || 0;
        const totalCompleted = product.total_completed_pieces || 0;

        if (partialQty < 0 || partialQty > totalCompleted) {
          hasValidationError = true;
        }
      });

      if (hasValidationError) {
        toast.error("Please correct partial quantities");
        return;
      }

      // Determine status based on quantity comparison
      const statusToUpdate =
        sumOfPartialQuantities === totalQuantityInPieces
          ? "dispatch"
          : "processing";

      // Prepare payload
      const payload = {
        vehicleDetails: {
          vehicleNumber,
          vehicleType,
          driverName,
          dispatcherName,
          value: "1",
        },
        notes,
        products: partialDispatchProducts.map((product) => ({
          product_id: product.product_id,
          updateQuanInPic: Number(partialQuantities[product.product_id]) || 0,
        })),
      };

      console.log("Sending Payload:", payload);

      // Call changeStatus
      await changeStatus(selectedOrderIndex, statusToUpdate, payload);

      toast.success(
        statusToUpdate === "dispatch"
          ? "Order dispatched successfully!"
          : "Order processing status updated!",
      );

      // Reset form and state
      setModalState((prev) => ({ ...prev, showPartialDispatch: false }));
      setPartialDispatchData({
        vehicleNumber: "",
        vehicleType: "",
        driverName: "",
        dispatcherName: "",
        notes: "",
        partialQuantities: {},
      });
    } catch (error) {
      console.error("Error saving partial dispatch:", error);
      toast.error(
        error.response?.data?.message ||
          "An error occurred while saving partial dispatch",
      );
    } finally {
      setIsProcessing((prev) => ({ ...prev, partialDispatch: false }));
      hideLoader?.();
    }
  }, [
    partialDispatchData,
    partialDispatchProducts,
    selectedOrderIndex,
    totalQuantityInPieces,
    changeStatus,
    setModalState,
    toast,
  ]);

  const handleDispatchRemarksSave = useCallback(
    async (order, data) => {
      setIsProcessing((prev) => ({ ...prev, saving: true }));
      console.log("handleDispatchRemarksSave called with:", order, data);
      showLoader?.();

      // Find the index of the order
      const index = orders.findIndex((o) => o.orderId === order.orderId);
      if (index === -1) {
        toast.error("Order not found");
        setIsProcessing((prev) => ({ ...prev, saving: false }));
        hideLoader?.();
        return;
      }

      try {
        await changeStatus(index, "dispatch", {
          dispatchRemark: data.dispatchRemark,
          attachments: data.attachments,
          dispatchDate: data.dispatchDate,
        });

        setModalState((prev) => ({ ...prev, showDispatchRemarks: false }));
        // No need to reset state here as it's managed by the component
      } catch (error) {
        console.error("Error dispatching order:", error);
        toast.error(
          error.response?.data?.message || "Failed to dispatch order",
        );
      } finally {
        setIsProcessing((prev) => ({ ...prev, saving: false }));
        hideLoader?.();
      }
    },
    [orders, changeStatus, setModalState, toast],
  );

  const handleDispatchDateSave = useCallback(
    async (orderId, date, id) => {
      console.log("=== DISPATCH DATE SAVE DEBUG ===");
      console.log("orderId:", orderId);
      console.log("date:", date, typeof date);
      console.log("id:", id, typeof id);

      setIsProcessing((prev) => ({ ...prev, savingDispatchId: orderId }));
      showLoader?.();

      try {
        if (!date) {
          console.error("No date provided");
          toast.error("Please select a dispatch date");
          return;
        }

        // Ensure date is in YYYY-MM-DD format
        let formattedDate = date;
        if (date.includes("/")) {
          const parts = date.split("/");
          formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        } else if (date.includes("-") && date.split("-")[0].length === 4) {
          // Already YYYY-MM-DD
          formattedDate = date;
        } else if (date.includes("-")) {
          const parts = date.split("-");
          if (parts[2].length === 4) {
            // DD-MM-YYYY
            formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
        }

        const payload = {
          neworderid: orderId,
          dispatch_date_production: formattedDate,
          order: {
            _id: id,
          },
        };

        console.log("Final payload:", JSON.stringify(payload, null, 2));

        await updateOrderDispatchDate(payload);
        toast.success("Dispatch date updated successfully");
        await refreshOrders();
      } catch (error) {
        console.error("Error in handleDispatchDateSave:", error);
        console.error("Error response:", error.response?.data);
        toast.error(
          error.response?.data?.message || "Failed to update dispatch date",
        );
      } finally {
        setIsProcessing((prev) => ({ ...prev, savingDispatchId: null }));
        hideLoader?.();
      }
    },
    [refreshOrders, updateOrderDispatchDate, toast],
  );

  const handleQueueSubmit = useCallback(
    async (orderId, productId, queueIds) => {
      setIsProcessing((prev) => ({ ...prev, queue: true }));
      showLoader?.();
      try {
        await addQueData(orderId, productId, queueIds);
        toast.success("Queue updated successfully");
        await refreshOrders();
        setModalState((prev) => ({ ...prev, showQueue: false }));
      } catch (error) {
        console.error("Error submitting queue:", error);
        toast.error(error?.response?.data?.message || "Failed to submit queue");
      } finally {
        setIsProcessing((prev) => ({ ...prev, queue: false }));
        hideLoader?.();
      }
    },
    [refreshOrders, setModalState, addQueData, toast],
  );

  const handleMediaPreview = useCallback(
    async (product, orderId) => {
      setIsProcessing((prev) => ({ ...prev, loading: true }));
      showLoader?.();
      setSelectedProduct(product);
      try {
        const response = await ViewOrderProductImage({ neworderid: orderId });
        setModalState((prev) => ({ ...prev, showMedia: true }));
        return response;
      } catch (error) {
        console.error("Error fetching product images:", error);
        toast.error("Failed to load media");
        setModalState((prev) => ({ ...prev, showMedia: true }));
        return { images: [], pdfs: [] };
      } finally {
        setIsProcessing((prev) => ({ ...prev, loading: false }));
        hideLoader?.();
      }
    },
    [setSelectedProduct, setModalState, ViewOrderProductImage, toast],
  );

  const handleProductClick = useCallback(
    (product, orderId) => {
      setSelectedProduct(product);
      setModalState((prev) => ({ ...prev, showProductionDetails: true }));
    },
    [setSelectedProduct, setModalState],
  );

  const handleStatusLabelClick = useCallback(
    (order) => {
      setSelectedOrder(order);
      setModalState((prev) => ({ ...prev, showStatusLabel: true }));
    },
    [setSelectedOrder, setModalState],
  );

  const saveUpdatedProductDetails = useCallback(
    async (rowData, index) => {
      setIsProcessing((prev) => ({ ...prev, saving: true }));
      showLoader?.();
      try {
        console.log("Saving product details with data:", rowData);

        const payload = {
          companyID: 1,
          order_id: rowData.order_id,
          product_id: rowData.product_id,
          production_update_id:
            rowData._id?.toString() || rowData.id?.toString(),
          pcs_cast: rowData.pcs_cast,
          damage: rowData.damage,
          department: rowData.department,
          operation: rowData.operation || "plus",
        };

        console.log("Final payload:", payload);

        await EditUpdateQuaintity(payload);
        toast.success("Product details updated successfully");
        await refreshOrders();
        setModalState((prev) => ({ ...prev, showProductionDetails: false }));
      } catch (error) {
        console.error("Error while updating product details:", error);
        toast.error(
          error.response?.data?.message || "Failed to update product details",
        );
      } finally {
        setIsProcessing((prev) => ({ ...prev, saving: false }));
        hideLoader?.();
      }
    },
    [refreshOrders, setModalState, EditUpdateQuaintity, toast],
  );

  const handleDeleteRow = useCallback(
    async (rowData) => {
      setIsProcessing((prev) => ({ ...prev, deleting: true }));
      showLoader?.();
      try {
        const payload = {
          companyID: 1,
          order_id: rowData.order_id,
          product_id: rowData.product_id,
          production_update_id: rowData._id.toString(),
        };

        await deleteProductionHistory(payload);
        toast.success("Production update deleted successfully");
        await refreshOrders();
      } catch (error) {
        console.error("Error deleting production history:", error);
        toast.error(
          error.response?.data?.message || "Failed to delete production update",
        );
      } finally {
        setIsProcessing((prev) => ({ ...prev, deleting: false }));
        hideLoader?.();
      }
    },
    [refreshOrders, deleteProductionHistory, toast],
  );

  const handleDeleteMedia = useCallback(
    async (item, orderId, productId) => {
      setIsProcessing((prev) => ({ ...prev, deleting: true }));
      showLoader?.();
      try {
        const payload = {
          neworderid: orderId,
          type: item.deleteImageType || (item.type === "pdf" ? "pdf" : "image"),
          ...(item.source !== "files" && { product_id: productId }),
          ...(item.id && { image_id: item.id, file_id: item.id }),
          deleteImageType:
            item.deleteImageType || (item.type === "pdf" ? "pdf" : "image"),
        };

        await deleteProductImage(payload);
        toast.success(
          `${item.type === "image" ? "Image" : "PDF"} deleted successfully!`,
        );

        if (searchValue) {
          await debouncedSearch(searchField, searchValue);
        } else {
          await refreshOrders();
        }
      } catch (error) {
        console.error(`Failed to delete ${item.type}:`, error);
        toast.error(
          error.response?.data?.message || `Failed to delete ${item.type}`,
        );
      } finally {
        setIsProcessing((prev) => ({ ...prev, deleting: false }));
        hideLoader?.();
      }
    },
    [
      refreshOrders,
      debouncedSearch,
      searchField,
      searchValue,
      deleteProductImage,
      toast,
    ],
  );

  const fetchOrderLogs = useCallback(
    async (order) => {
      const id = order?.orderId || order?.neworderid || "";
      if (!id) {
        toast.error("Order id missing");
        return [];
      }

      try {
        const res = await getOrderLogs(id, order?.neworderid, order?._id);
        return res;
      } catch (err) {
        console.error("Error fetching order logs:", err);
        return [];
      }
    },
    [getOrderLogs, toast],
  );

  const handleViewLogs = useCallback(
    async (order) => {
      showLoader?.();
      try {
        const res = await fetchOrderLogs(order);
        const logs = res?.data || res || [];
        setLogsContent(Array.isArray(logs) ? logs : []);
        setLogsOrderId(order.orderId || order.neworderid || "");
        setModalState((prev) => ({ ...prev, showLogs: true }));
      } catch (err) {
        console.error("Error fetching logs:", err);
        setLogsContent([]);
        setLogsOrderId(order.orderId || order.neworderid || "");
        setModalState((prev) => ({ ...prev, showLogs: true }));
      } finally {
        hideLoader?.();
      }
    },
    [fetchOrderLogs, setLogsContent, setLogsOrderId, setModalState],
  );

  // Helper function
  const extractRelativePath = (url) => {
    if (!url) return url;
    if (!url.includes("http://") && !url.includes("https://")) {
      return url;
    }
    const uploadsIndex = url.indexOf("uploads/");
    if (uploadsIndex !== -1) {
      return url.substring(uploadsIndex);
    }
    return url;
  };

  // Expose partial dispatch state for components that need it
  const partialDispatchState = {
    partialDispatchData,
    setPartialDispatchData,
    partialDispatchProducts,
    setPartialDispatchProducts,
    selectedOrderIndex,
    setSelectedOrderIndex,
    pendingStatus,
    setPendingStatus,
    totalQuantityInPieces,
    setTotalQuantityInPieces,
    dispatchRemark,
    setDispatchRemark,
    attachments,
    setAttachments,
    dispatchDate,
    setDispatchDate,
  };

  return {
    isProcessing,
    handleEditOrder,
    handleDeleteOrder,
    handleQuantity,
    handleStatusChange,
    handlePartialDispatchSave,
    handleDispatchRemarksSave,
    handleDispatchDateSave,
    handleQueueSubmit,
    handleMediaPreview,
    handleProductClick,
    handleStatusLabelClick,
    saveUpdatedProductDetails,
    handleDeleteRow,
    handleDeleteMedia,
    fetchOrderLogs,
    handleViewLogs,
    partialDispatchState, // Export for components that need access
  };
};
